import { BigNumber } from "ethers";
import React from "react";

export type SaleContextValue = {
  isSaleActive?: boolean;
  price?: BigNumber;
  honeyReward?: BigNumber;
  readSaleState: () => void;
  readPrice: () => void;
  readHoneyReward: () => void;
};

const SaleContext = React.createContext<SaleContextValue>({
  readSaleState: () => {},
  readPrice: () => {},
  readHoneyReward: () => {},
});

export default SaleContext;
